
































// This component fetches a list of stories and displays them as a list of StoryComponent's
import { Component, Prop, Vue } from 'vue-property-decorator';
import { StoryUser } from '../StoryUser'
import { Story, statusType, privacyType } from '../Story'
import * as utils from '../utils';
import * as utils_time from '../utils_time';
import * as utils_auth from '../utils_auth';
import { globalUC } from '../UserCache'
import AvatarComponent from '@/components/AvatarComponent.vue';           // @ is an alias to /src
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

// TODO: show pendingOutgoingFollowing in the circle, but dimmed out
const DEBUGGING: boolean = false

@Component({
  name: 'UserCircleComponent',
  components: { AvatarComponent, ModalWrapperComponent }
})
export default class UserCircleComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public startingUid: string

  @Prop({ default: null })
  public startingUser: StoryUser

  // public reactive member variables available to the html template
  public uid: string = this.startingUid
  public u: StoryUser = this.startingUser ? new StoryUser(this.startingUser) : null
  public smallAvatarSize: number = 46
  public centerAvatarSize: number = 140
  public minNumberSmallAvatars: number = 12
  public numGhostAvatars: number = this.minNumberSmallAvatars
  public circleUsers: StoryUser[] = null
  public enableInviting: boolean = false

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading; }
  public get user(): StoryUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public get isAuthenticated(): boolean { return this.$store.getters.isAuthenticated }
  public get isMe(): boolean { return this.u && this.userId === this.u.getIdAsString() }

  public fakeAvatarUsername(n: number): string {
    return (this.enableInviting ? '+' : ' ') + '  '.repeat(n)
  }

  public async clickedSelf() {
    this.$emit('close', true)
    const needToRefresh: boolean = this.$route.path.startsWith('/user/')
    try { await this.$router.push(`/user/${this.userId}`) } catch (Error) {}
    // if (needToRefresh) await this.$router.go(0)      // necessary because if already on user page, it doesn't go -- don't need to do this anymore because I do it instead in User.vue's pathChanged()
    // this.$nextTick(() => {
    //  this.$router.push({ name: 'user', params: { id: friend.getIdAsString(), user: friend as any}})
    // })
  }

  public async clickedFriend(friend: StoryUser) {
    this.$emit('close', true)
    const needToRefresh: boolean = this.$route.path.startsWith('/user/')
    try { await this.$router.push(`/user/${friend.getIdAsString()}`) } catch (Error) {}
    // if (needToRefresh) await this.$router.go(0)      // necessary because if already on user page, it doesn't go -- don't need to do this anymore because I do it instead in User.vue's pathChanged()
    // this.$nextTick(() => {
    //  this.$router.push({ name: 'user', params: { id: friend.getIdAsString(), user: friend as any}})
    // })
  }

  // e.g. UserCircleComponent.onModalShow(InvitesFormComponent, false, true)
  public async onModalShow(componentName: string, modalShowing: boolean, invitedSomeone: boolean) {
    if (DEBUGGING) console.log(`UserCircleComponent.onModalShow(${componentName}, ${modalShowing}, ${invitedSomeone})`)
    if (!modalShowing && invitedSomeone) {
      this.u = await globalUC.get(this.uid, true)
      this.circleUsers = null
      await this.fetchData()
      this.doLayout()
    }
  }

  public invite(): void {
    if (!this.enableInviting) return
    const modalTitle: string = 'Invite To Your Listening Circle';
    (this.$refs.InvitesFormModalComponent as ModalWrapperComponent).show(modalTitle, 'md', { invitedByName: this.user.firstName })
  }
  // private, non-reactive member variables

  // 0, 0 means put elem in center of parentElem
  // Note: https://www.w3schools.com/css/css_positioning.asp - to me, it's weird nomenclature
  //       https://stackoverflow.com/questions/17909465/relative-and-absolute-positioning-confusion
  private position(parentElem: HTMLElement, elem: HTMLElement, x: number, y: number) {
    parentElem.style.position = 'relative'    // parent element must be "positioned" in some way to serve as the anchor point for children that are positioned as absolute
    const left: number = x - elem.clientWidth / 2 + parentElem.clientWidth / 2
    const top: number = y - elem.clientHeight / 2 + parentElem.clientHeight / 2
    elem.style.position = 'absolute'
    elem.style.left = left.toString() + 'px'
    elem.style.top = top.toString() + 'px'
  }

  // TODO: need to call this after in resizes or else not real-time reactive the way a pure CSS method would do
  private doLayout() {
    if (!this.u) return

    const circleContainerDiv: HTMLDivElement = this.$refs.circleContainer as HTMLDivElement
    const centerAvatarComponent: Vue = this.$refs.centerAvatar as Vue
    const centerAvatarDiv = centerAvatarComponent.$el as HTMLDivElement
    let smallAvatarDivs: HTMLDivElement[] = this.$refs.smallAvatars as HTMLDivElement[]
    let smallAvatarFakeDivs: HTMLDivElement[] = this.$refs.smallAvatarsFake as HTMLDivElement[]

    if (!smallAvatarDivs) smallAvatarDivs = []
    if (!smallAvatarFakeDivs) smallAvatarFakeDivs = []

    // put centerAvatar in middle
    this.position(circleContainerDiv, centerAvatarDiv, 0, 0)

    // arrange all smallAvatars around
    // first the real ones
    const increase = Math.PI * 2 / (smallAvatarDivs.length + smallAvatarFakeDivs.length)
    let angle: number = -Math.PI * 2 / 4
    const distanceFromMiddle: number = centerAvatarDiv.clientWidth / 2 + this.smallAvatarSize / 2 + 12
    if (DEBUGGING) {
      console.dir(centerAvatarDiv)
      console.log(centerAvatarDiv.clientWidth)
      console.log(distanceFromMiddle)
    }
    for (const smallAvatarDiv of smallAvatarDivs) {
      const x = distanceFromMiddle * Math.cos(angle)
      const y = distanceFromMiddle * Math.sin(angle)
      this.position(circleContainerDiv, smallAvatarDiv, x, y)
      angle += increase
    }
    // then the ghost ones -- "+        "
    for (const smallAvatarFakeDiv of smallAvatarFakeDivs) {
      const x = distanceFromMiddle * Math.cos(angle)
      const y = distanceFromMiddle * Math.sin(angle)
      this.position(circleContainerDiv, smallAvatarFakeDiv, x, y)
      angle += increase
    }
  }

  // when used inside a modal
  public async onShow(dynamicProps: any) {
    if (DEBUGGING) console.log('UserCircleComponent.onShow()...')
    // total hack for two reasons:
    // 1) if I call this.doLayout() without a delay, centerAvatarDiv.clientWidth will be 0 instead of 150 (dunno why)
    // 2) avoid race condition where we call await this.fetchData() while this.fetchData() already in progress and it messes up
    await utils.sleep(100)
    while (this.loading) await utils.sleep(100)
    this.circleUsers = null
    if (dynamicProps && dynamicProps.startingUid) this.uid = dynamicProps.startingUid
    if (dynamicProps && dynamicProps.startingUser) this.u = dynamicProps.startingUser
    if (dynamicProps && dynamicProps.enableInviting) this.enableInviting = dynamicProps.enableInviting
    await this.fetchData()
    this.doLayout()
  }

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name)

    await this.fetchData()
    this.doLayout();

    // if (this.$store.state.devmode) console.dir(this.u)
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

  private async fetchData(): Promise<void> {
    if (!this.uid) {
      if (DEBUGGING) console.log('fetchData no this.uid')
      return
    }
    this.$store.commit('setLoading', { loading: true });
    try {
      // fetch user first if we need to
      if (!this.u) {
        if (DEBUGGING) console.log('fetching user...')
        this.u = await globalUC.get(this.uid, true)
      }
      if (this.u && !this.circleUsers) {
        if (DEBUGGING) console.log(`fetching ${this.u.getCircle().followedBy.length} followers of ${this.u.email}'s circle`, this.u.getCircle().followedBy)
        this.circleUsers = []
        for (const cuid of this.u.getCircle().followedBy) this.circleUsers.push(await globalUC.get(cuid, false))
        this.numGhostAvatars = this.minNumberSmallAvatars - this.circleUsers.length
        if (this.numGhostAvatars < 0) this.numGhostAvatars = 0
      }
    } catch (error) {
      utils.toast(this, 'Error', 'Could not load user and/or circleUsers')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }
  }

}
